import { get } from 'lodash';
import React from 'react';
import Roman from 'roman-numerals';
import { KOSTEN_ARTEN, KOSTEN_POSITION, PROJEKTDURCHFUERUNG } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { enumT } from '../../../../../../utils/helper';

import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import DurchfuehrungOrganisationAntragEPZ, { getFormStrucDurchfuehrungOrganisationAntragEPZ } from './content/DurchfuehrungOrganisation';
import KostenUebersichtAntragEpz from './content/KostenUebersichtAntragEpz';
import ProjektDatenAntragEPZ, { getFormStrucProjektDatenAntragEPZ } from './content/ProjektDatenAntragEPZ';
import EinnahmenEPZ, { getFormStrucEinnahmenEPZ } from './content/einnahme/EinnahmenEPZ';
import FinanzierungsplanEPZ, { getFormStrucFinanzierungsplanEPZ } from './content/finanzierungsplan/FinanzierungsplanEPZ';
import PersonalKostenEPZ, { getFormStrucPersonalKostenEPZ } from './content/personalkosten/PersonalKosten';
import BeitragZumFoerderziel, { getFormStrucBeitragZumFoerderziel } from './content/projektbeschreibung/BeitragFoerderziel';
import BesondereFoerderwuerdigkeit, { getFormStrucBesondereFoerderwuerdigkeit } from './content/projektbeschreibung/BesondereFoerderwuerdigkeit';
import KurzbeschreibungEPZ, { getFormStrucKurzbeschreibungEPZ } from './content/projektbeschreibung/Kurzbeschreibung';
import ProjektBeschreibungEPZ, { getFormStrucProjektBeschreibungEPZ } from './content/projektbeschreibung/ProjektBeschreibungPruefAssistenz';
import ProjektbewertungEPZ, { getFormStrucProjektbewertungEPZ } from './content/projektbeschreibung/ProjektbewertungEPZ';
import ZielgruppeEPZ, { getFormStrucZielgruppeEPZ } from './content/projektbeschreibung/ZielgruppeEPZ';
import ReisekostenEPZ, { getFormStrucReisekostenEPZ } from './content/reisekosten/ReiseKostenEPZ';
import SachkostenEPZ, { getFormStrucSachkostenEPZ } from './content/sachkosten/SachkostenEPZ';
import VerwaltungskostenEPZ, { getFormStrucVerwaltungskostenEPZ } from './content/verwaltungskosten/VerwaltungskostenEPZ';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAntragEPZ = (
	application: any,
	kostenKategoriesGroup: any,
	readOnly: boolean,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
): TreeNodeType[] => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// ALlgemeine Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projekt Daten
		{
			label: 'Projektdaten',
			content: <ProjektDatenAntragEPZ hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektDatenAntragEPZ(application),
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Durchführungsorganisation
		...DurchfuehrungOrganisationStructure(application, readOnly),
		// Projektbeschreibung
		...ProjektBeschreibung(application, readOnly),
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// KostenPostitions
		...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...SachKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...ReiseKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...VerwaltungspauschalenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...EinnahmenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		// Finanzierungsplan
		// ...TreeStructureAntragFinanzierungsPlanGlobal(application),
		{
			label: 'Ausgaben- und Finanzierungsplan',
			content: <FinanzierungsplanEPZ />,
			formStruc: getFormStrucFinanzierungsplanEPZ(application),
			isSummaryReport: true,
			hasComment: isKostenEditable,
		},
		// Anlagen und Erkörung Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const DurchfuehrungOrganisationStructure = (application: any, readOnly: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (
		get(application, P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektdurchfuehrung.path) === PROJEKTDURCHFUERUNG.ausland
	) {
		const hasCommentDurchfuehrungsorganisation = checkIfHasComment(
			readOnly,
			application,
			P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Durchfuehrungsorganisation_Pruefstatus.path,
		);
		nodes = [
			{
				label: 'Durchführungsorganisation',
				content: <DurchfuehrungOrganisationAntragEPZ hasComment={hasCommentDurchfuehrungsorganisation} />,
				formStruc: getFormStrucDurchfuehrungOrganisationAntragEPZ(application),
				hasComment: hasCommentDurchfuehrungsorganisation,
			},
		];
	}
	return nodes;
};
const ProjektBeschreibung = (application: any, readOnly: boolean) => {
	const hasCommentProjektbeschreibung = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Pruefung_Projektbeschreibung_Pruefstatus.path,
	);
	let nodes: TreeNodeType[] = [
		{
			label: 'Projektbeschreibung',
			content: <ProjektBeschreibungEPZ />,
			formStruc: getFormStrucProjektBeschreibungEPZ(application),
			children: [
				{
					label: `${Roman.toRoman(1) + '. '} Beitrag zum Förderziel`,
					content: <BeitragZumFoerderziel hasComment={hasCommentProjektbeschreibung} />,
					formStruc: getFormStrucBeitragZumFoerderziel(application),
				},
				{
					label: `${Roman.toRoman(2) + '. '} Projektbeschreibung`,
					content: <KurzbeschreibungEPZ hasComment={hasCommentProjektbeschreibung} />,
					formStruc: getFormStrucKurzbeschreibungEPZ(application),
				},
				{
					label: `${Roman.toRoman(3) + '. '} Besondere Förderwürdigkeit`,
					content: <BesondereFoerderwuerdigkeit hasComment={hasCommentProjektbeschreibung} />,
					formStruc: getFormStrucBesondereFoerderwuerdigkeit(application),
				},
				{
					label: `${Roman.toRoman(4) + '. '} Zielgruppe`,
					content: <ZielgruppeEPZ hasComment={hasCommentProjektbeschreibung} />,
					formStruc: getFormStrucZielgruppeEPZ(application),
				},
				{
					label: `${Roman.toRoman(5) + '. '} Projektbewertung`,
					content: <ProjektbewertungEPZ hasComment={hasCommentProjektbeschreibung} />,
					formStruc: getFormStrucProjektbewertungEPZ(application),
				},
			],
			hasComment: hasCommentProjektbeschreibung,
		},
	];
	return nodes;
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Personalkosten),
				content: <PersonalKostenEPZ hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				formStruc: getFormStrucPersonalKostenEPZ(application),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Personalkosten)} Übersicht`,
				content: <KostenUebersichtAntragEpz kostenArt={KOSTEN_ARTEN.Personalkosten} />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Sachkosten),
				content: <SachkostenEPZ hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				formStruc: getFormStrucSachkostenEPZ(application),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Sachkosten)} Übersicht`,
				content: <KostenUebersichtAntragEpz kostenArt={KOSTEN_ARTEN.Sachkosten} />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const ReiseKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Reisekosten)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Reisekosten),
				content: <ReisekostenEPZ hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Reisekosten),
				formStruc: getFormStrucReisekostenEPZ(application),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Reisekosten)} Übersicht`,
				content: <KostenUebersichtAntragEpz kostenArt={KOSTEN_ARTEN.Reisekosten} />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const VerwaltungspauschalenStructure = (
	application: any,
	kostenKategoriesGroup: any,
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung?: boolean,
) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Verwaltungskostenpauschale)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Verwaltungskostenpauschale),
				content: <VerwaltungskostenEPZ hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Verwaltungskostenpauschale),
				formStruc: getFormStrucVerwaltungskostenEPZ(application),
			},
		];
	}
	return nodes;
};
const EinnahmenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Eigenmittel),
				content: <EinnahmenEPZ hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				formStruc: getFormStrucEinnahmenEPZ(application),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Eigenmittel)} Übersicht`,
				content: <KostenUebersichtAntragEpz kostenArt={KOSTEN_ARTEN.Eigenmittel} />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
